import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { useOrganization } from "hooks";
import { Select } from "components/Form";
import { Spinner } from "components/Loader";
import { CUSTOMER_PORTAL_VERSION_OPTIONS } from "constants/index";

/**
 * OrganizationCustomerPortalVersionSelector
 *
 * @param {Object}  data     Organization data
 * @param {Boolean} loading
 * @param {Boolean} disabled  Shows the version without letting it be switched
 */
const OrganizationCustomerPortalVersionSelector = ({ data, loading, disabled }) => {
  const intl = useIntl();
  const { handleCustomerPortalVersionChange, settingCustomerPortalVersion } = useOrganization();
  const [selection, setSelection] = useState(data?.customerPortalVersion);

  useEffect(() => {
    setSelection(data?.customerPortalVersion);
  }, [data?.customerPortalVersion]);

  const options = CUSTOMER_PORTAL_VERSION_OPTIONS.map(({ value, labelId }) => ({
    value,
    label: intl.formatMessage({ id: labelId }),
  }));

  const handleChange = (version) => {
    if (!version || version === selection) return;

    setSelection(version);
    handleCustomerPortalVersionChange({ orgId: data?.id, customerPortalVersion: version });
  };

  if (loading) return <Spinner size="1.5rem" />;

  return (
    <Select
      options={options}
      onChange={(_name, val) => handleChange(val)}
      value={selection}
      loading={settingCustomerPortalVersion}
      disabled={disabled || settingCustomerPortalVersion}
    />
  );
};

OrganizationCustomerPortalVersionSelector.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    customerPortalVersion: PropTypes.string,
  }),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default OrganizationCustomerPortalVersionSelector;
